import {
    consoleLogHandler,
    getSearchParams,
    initializeLogging as initializeVinylLogging,
    LogLevel,
    parseLogLevel,
    setLogLevel,
} from '@amazon/vinyl-util'
import { debug } from '@/core/debug'
import { startLogStream } from '@/core/logStream'
import { installLogRedaction } from '@/redactSensitive'

export const LOG_LEVEL_STORAGE_KEY = 'logLevel'

/** Raw `localStorage`: the boot-time log-level setup is synchronous, which a persistent item's async `get()` cannot serve. */
export function readStoredLogLevel(): string | null {
    try {
        return typeof localStorage !== 'undefined'
            ? localStorage.getItem(LOG_LEVEL_STORAGE_KEY)
            : null
    } catch {
        return null
    }
}

export function writeStoredLogLevel(level: string): void {
    try {
        localStorage.setItem(LOG_LEVEL_STORAGE_KEY, level)
    } catch {
        // Storage may be blocked (private browsing); the preference then lasts the session only.
    }
}

function resolveConsoleLogLevel(): LogLevel {
    const param = getSearchParams().get('logLevel')
    const fromParam = param ? parseLogLevel(param) : null
    if (fromParam != null) return fromParam
    const stored = readStoredLogLevel()
    const fromStored = stored ? parseLogLevel(stored) : null
    if (fromStored != null) return fromStored
    return debug ? LogLevel.DEBUG : LogLevel.WARN
}

/** Runs at boot and when the debug panel toggle flips. Only VERBOSE also raises the main gate, which defaults to DEBUG and would drop it. */
export function applyConsoleLogLevel(): void {
    const level = resolveConsoleLogLevel()
    const cLH = consoleLogHandler.value
    if (cLH) cLH.logLevel = level
    if (level === LogLevel.VERBOSE) setLogLevel(LogLevel.VERBOSE)
}

export function initializeLogging(): void {
    installLogRedaction()
    initializeVinylLogging()
    applyConsoleLogLevel()
    startLogStream()
}
